import React, { useEffect } from 'react';
import { useAuth } from 'src/hooks/use-auth';

export const AuthCallback = () => {
  const { signIn } = useAuth();
  useEffect(() => {
    signIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};
